module.exports = __webpack_public_path__ + "img/icon_01.8acc644e.png";